
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { MediaInputValue, MediaOptions } from "@/types/media";
import MediaUploadDialog from "@/components/Reusable/CustomInputs/MediaInput/MediaUploadDialog.vue";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: {
    MediaUploadDialog
  }
})
export default class SingularityMediaUploadDialog extends Vue {
  @Prop()
  value?: MediaInputValue;

  @Prop()
  mediaInputOptions?: MediaOptions;

  @Prop()
  multiple!: false;

  @Prop()
  dialogOpen!: false;

  @Prop({ default: "library" })
  activeTab!: "upload" | "library";

  @Watch("dialogOpen", { immediate: true })
  onDialogOpenChange(newVal: boolean) {
    this.open = newVal;
  }

  open = false;

  get acceptedFileTypes() {
    return this.mediaInputOptions?.acceptedFileTypes || [];
  }

  updateValue(newValue?: MediaInputValue) {
    this.$emit("input", newValue);
  }

  async onMediaSelected(media: MediaInputValue) {
    const newValue = defensiveCopy(this.value);

    if (Array.isArray(newValue) && Array.isArray(media)) {
      // If we are in gallery mode, we append to the end of the array.
      newValue.push(...media);
      this.updateValue(newValue);
    } else {
      // Otherwise replace the current image with the new one.
      this.updateValue(media);
    }
  }
}
